// components/TawkToChat.jsx
import { useEffect } from "react";

const TawkToChat = () => {
   useEffect(() => {
      const script = document.createElement("script");
      script.src = "https://embed.tawk.to/67f7470518d2ac190c62b1d2/1ioeuqsaq";
      script.async = true;
      script.charset = "UTF-8";
      script.setAttribute("crossorigin", "*");
      document.body.appendChild(script);

      return () => {
         document.body.removeChild(script); // Cleanup on unmount
      };
   }, []);

   return null; // No visual UI needed
};

export default TawkToChat;
